query GetContact($input: GetContactInput!) {
    getContact(input: $input) {
        id
        hubspotId
        hubspotCompanyId
        firstName
        lastName
        email
        phoneNumber
        address
        zipCode
        city
        message
    }
}
